<template>
  <div>
    <ul
      class="context-menu-list fk-projectContextMenu context-menu-root"
      :style="{
      top:$store.state.row_contextmenu_dialog.top + 'px',
      left:$store.state.row_contextmenu_dialog.left + 'px',
      }"
    >
      <li
        class="context-menu-item f-icon-J_rowCopy"
        @click="copy_module"
        v-if="is_module && !is_system_module"
      >
        <div>
          <span>{{$t('components_my_row_contextmenu_dialog_index_2433')}}</span>
        </div>
      </li>
      <li
        class="context-menu-item"
        @click="show_pop($t('components_my_row_contextmenu_dialog_index_2434'))"
        v-if="!is_body_system_row && rowType != 'header' && is_module"
      >
        <div>
          <span>{{$t('components_my_row_contextmenu_dialog_index_2434')}}</span>
        </div>
      </li>
      <li class="context-menu-item context-menu-align" v-if="is_module && has_moadule_align">
        <div class="module_align">
          <span>{{$t('components_my_row_contextmenu_dialog_index_2435')}}</span>
        </div>
        <span class="interval_layer"></span>
        <ul class="context-menu-list fk-projectContextMenu context-menu-root sub_module_align">
          <li
            class="context-menu-item"
            :class="item.icon_class"
            v-for="(item,index) in $store.state.options.moduleAlign"
            :key="index"
            @click="seModuleAlign(item)"
          >
            <div :class="infor.textAlign === item.value ? 'f-active': ''">
              <div class="f-icon"></div>
              <span v-text="$t(item.title)"></span>
            </div>
          </li>
        </ul>
      </li>

      <li
        class="context-menu-item f-icon-J_rowCopy"
        @click="copy_row"
        v-if="!is_body_system_row  && !has_system_module && rowType != 'full_screen_banner'"
      >
        <div>
          <span>{{$t('components_my_row_contextmenu_dialog_index_2436')}}</span>
        </div>
      </li>

      <li
        class="context-menu-item f-icon-J_rowCopy"
        @click="save_row"
        v-if="!is_body_system_row && rowType == 'body' && $store.state.app.view_pattern === 'pc'"
      >
        <div>
          <span>{{addMaterialTip}}</span>
        </div>
      </li>

      <li class="context-menu-item" @click="show_pop($t('vuex_modules_anchor_296'))"
          v-if="rowType != 'header' && rowType != 'full_screen_banner'">
        <div>
          <span>{{$t('vuex_modules_anchor_296')}}</span>
        </div>
      </li>
      <li
        class="context-menu-item f-icon-J_moveRowToCol context-menu-visible"
        @click="page_add_row"
        v-if="!is_body_system_row && rowType == 'body' && !is_system_module"
      >
        <div>
          <span>{{$t('components_my_row_contextmenu_dialog_index_2437')}}</span>
        </div>
      </li>
    </ul>
    <div class="contextmenu_mongolia" @click="close_dialog"></div>
  </div>
</template>

<script>
import i18n from '../../language/index'

import {p_save} from "@/api/app";

export default {
  name: "row_contextmenu_dialog",
  data() {
    return {
      contentAlignIsShow: false
    };
  },
  computed: {
    infor() {
      return this.$store.state.row_contextmenu_dialog.contextmenu_module.data[
      this.$store.state.app.view_pattern + "_infor"
        ];
    },
    pid() {
      return this.$store.state.row_contextmenu_dialog.contextmenu_module.pid;
    },
    widgets_id() {
      return this.$store.state.row_contextmenu_dialog.contextmenu_module
        .widgets_id;
    },
    moduleAlignShow() {
      let isShow = false;
      const module = this.$store.state.row_contextmenu_dialog
        .contextmenu_module;
      const arr = ["basic_picture", "basic_button", "basic_searchs"];
      const arr_filter = arr.filter(item => {
        return item.indexOf(module.name) > -1;
      });
      if (arr_filter.length > 0) {
        isShow = true;
      }
      return isShow;
    },
    is_body_system_row() {
      const data = this.$store.state.row_contextmenu_dialog.contextmenu_obj;
      if (data && data.data.body_system_row == "true") {
        return true;
      } else {
        return false;
      }
    },
    rowType() {
      const data = this.$store.state.row_contextmenu_dialog.contextmenu_obj;
      if (data) {
        return data.rowType;
      } else {
        false;
      }
    },
    has_system_module() {
      const data = this.$store.state.row_contextmenu_dialog.contextmenu_obj;
      if (data) {
        return this.templet.has_system_module(data);
      } else {
        return false;
      }
    },
    is_system_module() {
      const data = this.$store.state.row_contextmenu_dialog.contextmenu_module;
      if (
        data &&
        (data.data.is_system == "true" || data.data.isSystem == "true")
      ) {
        return true;
      } else {
        return false;
      }
    },

    is_module() {
      return this.$store.state.row_contextmenu_dialog.type === "module"
        ? true
        : false;
    },
    has_moadule_align() {
      const module = this.$store.state.row_contextmenu_dialog
        .contextmenu_module;
      return this.templet.has_moadule_align(module);
    },
    isDesigner() {
      return this.$store.state.app.role === 'designer'
    },
    addMaterialTip(){
      return this.isDesigner? i18n.t('components_material_save_dialog_index_2981') : i18n.t('components_material_save_dialog_index_2207')
    }
  },
  methods: {
    module_isHover(val) {
      this.contentAlignIsShow = val;
    },
    seModuleAlign(item) {
      this.infor.textAlign = item.value;
      let parentWidth = $(`#u${this.pid}`).width();
      let childDom = $(`#u${this.widgets_id}`);
      let childWidth = childDom.width();
      let percent = parseFloat(100 - (childWidth / parentWidth) * 100);
      if (this.infor.textAlign === "center") {
        percent = (percent / 2).toFixed(3);
        this.infor.marginLeft = percent + "%";
        this.infor.marginRight = percent + "%";
      } else {
        if (this.infor.textAlign === "left") {
          this.infor.marginLeft = "0%";
          this.infor.marginRight = percent.toFixed(3) + "%";
        } else {
          this.infor.marginLeft = percent.toFixed(3) + "%";
          this.infor.marginRight = "0%";
        }
      }
      this.close_dialog();
    },
    copy_row() {
      const select_row = this.$store.state.row_contextmenu_dialog
        .contextmenu_obj;

      if (select_row != null) {
        const new_row = this.templet.copy_one_row(select_row);
        const rowType = select_row.rowType;
        const find_select_row = this.templet.find_obj(select_row.widgets_id, [
          rowType
        ]);

        if (find_select_row) {
          this.$store.state.myRender[rowType].splice(
            find_select_row.row_index + 1,
            0,
            new_row
          );
          this.$nextTick(() => {
            this.templet.module_again_drag($(`.my${rowType}`));
            this.templet.row_scroll(new_row.widgets_id);
          });
        }
      }
      this.close_dialog();
    },
    close_dialog() {
      this.$store.commit("row_contextmenu_dialog/SET_isShow", false);
      this.$store.commit("row_contextmenu_dialog/SET_contextmenu_obj", null);
    },
    show_pop(word) {
      let select_row = null;
      if (word === i18n.t('vuex_modules_anchor_296')) {
        select_row = this.$store.state.row_contextmenu_dialog.contextmenu_obj;
      } else {
        select_row = this.$store.state.row_contextmenu_dialog
          .contextmenu_module;
      }
      this.$store.commit("anchor/SET_selectedData", select_row);
      this.$store.commit("anchor/SET_popShow", true);
      this.$store.commit("anchor/SET_popWord", word);
      this.close_dialog();
    },
    copy_module() {
      const select_module = this.$store.state.row_contextmenu_dialog
        .contextmenu_module;
      const select_row = this.$store.state.row_contextmenu_dialog
        .contextmenu_obj;
      if (select_module) {
        const new_module = this.templet.copy_one_module(select_module);
        const rowType = select_module.rowType;
        const find_select_module = this.templet.find_obj(
          select_module.widgets_id,
          [rowType]
        );

        if (find_select_module) {
          // select_row 是 row1
          if (find_select_module.isModuleInNewLayout && find_select_module.isTabModule) {
            select_row.children[find_select_module.col_index].children[find_select_module.row_2_index].children[find_select_module.col_2_index].children[find_select_module.module_index].children[find_select_module.tab_index].children.splice(
              find_select_module.tab_module_index + 1,
              0,
              new_module
            );
          } else if (find_select_module.isModuleInNewLayout) {
            select_row.children[find_select_module.col_index].children[find_select_module.row_2_index].children[find_select_module.col_2_index].children.splice(
              find_select_module.module_index + 1,
              0,
              new_module
            );
          } else if (find_select_module.isTabModule) {
            select_row.children[find_select_module.col_index].children[find_select_module.module_index].children[find_select_module.tab_index].children.splice(
              find_select_module.tab_module_index + 1,
              0,
              new_module
            );
          } else {
            select_row.children[find_select_module.col_index].children.splice(
              find_select_module.module_index + 1,
              0,
              new_module
            );
          }

          this.$nextTick(() => {
            this.templet.module_again_drag($(`#u${find_select_module.col_id}`));
            this.templet.row_scroll(new_module.widgets_id);
          });
        }
      }
      this.close_dialog();
    },
    save_row() {
      this.$store.commit("app/set_material_save_isShow", true);
      this.$store.commit("row_contextmenu_dialog/SET_isShow", false);
    },

    sys_is_change() {
      const row = this.$store.state.row_contextmenu_dialog.contextmenu_obj;
      let is_change = false;
      for (let i = 0; i < row.children.length; i++) {
        const col = row.children[i];
        if (col.widgets_id > 999999) {
          is_change = true;
          break;
        }
        for (let j = 0; j < col.children.length; j++) {
          const module = col.children[j];
          if (module.widgets_id > 999999) {
            is_change = true;
            break;
          }
        }
      }
      return is_change;
    },
    page_add_row() {
      this.$store.commit("row_contextmenu_dialog/SET_isShow", false);
      const row = this.$store.state.row_contextmenu_dialog.contextmenu_obj;
      const change = this.sys_is_change();
      if (this.$store.state.app.is_change || change) {
        //被修改过了
        this.$confirm(i18n.t('components_my_anchor_set_index_2235'), i18n.t('view_public_topbar_23'), {
          confirmButtonText: i18n.t('components_my_anchor_set_index_2236'),
          cancelButtonText: i18n.t('view_public_topbar_11'),
          center: true,
          // customClass: "del_dialog",
          appendToBody: true
        })
          .then(() => {
            this.templet.p_save(this.templet.p_init.bind(this.templet));
          })
          .catch(() => {
          });
      } else {
        //处理选中的ids

        this.$store.commit("page_add_row/SET_row", row);
        this.$store.commit("page_add_row/SET_isShow", true);

        this.$store.commit("row_contextmenu_dialog/SET_contextmenu_obj", null);
      }
    }
  }
};
</script>

<style scoped lang="scss">
.context-menu-item .module_align::after {
  content: "";
  display: block;
  position: absolute;
  right: 7px;
  top: 50%;
  margin-top: -3px;
  width: 8px;
  height: 8px;
  background: url(/static/image/mbg01.png) -484px -46px;
}

.fk-projectContextMenu .context-menu-item:hover .module_align::after {
  background: url(/static/image/mbg01.png) -936px -10px;
}

.context-menu-align {
  .interval_layer {
    width: 10px;
    height: 118px;
    position: absolute;
    left: 140px;
    top: 0;
    z-index: 99;
  }

  &:hover .sub_module_align {
    display: block;
  }

  .sub_module_align {
    display: none;
    left: 145px;
    top: 0;

    .f-active ::before {
      content: "";
      display: inline-block;
      position: absolute;
      left: 5px;
      top: 13px;
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background-color: #0078d7;
    }

    .f-icon {
      display: inline-block;
      width: 14px;
      height: 13px;
      margin-left: 8px;
      margin-right: 12px;
      vertical-align: middle;
      margin-top: -3px;
      background: url(/static/image/mbg01.png) no-repeat;
    }

    .context-menu-item {
      width: 118px;
      text-align: left;
    }

    .f-icon-aligentLeft .f-icon {
      background-position: -597px -11px;
    }

    .f-icon-aligentLeft:hover .f-icon {
      background-position: -690px -44px;
    }

    .f-icon-aligentRight .f-icon {
      background-position: -643px -11px;
    }

    .f-icon-aligentRight:hover .f-icon {
      background-position: -736px -44px;
    }

    .f-icon-aligentCenter .f-icon {
      background-position: -620px -11px;
    }

    .f-icon-aligentCenter:hover .f-icon {
      background-position: -713px -44px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/my_row_contextmenu_dialog/index.vue